'use strict';

var React = require('react');

var SvgTransactionFeeYenMajor = function SvgTransactionFeeYenMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 13a1 1 0 0 1 0 2c-2.206 0-4-1.794-4-4v-7h-1.184a2.997 2.997 0 0 1-2.816 2c-1.654 0-3-1.346-3-3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368a2.997 2.997 0 0 1 2.816-2c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2h-5.185v7c0 1.103.897 2 2 2zm6.475 3.454h1.25a.75.75 0 1 1 0 1.5h-1.25v1a1 1 0 0 1-2 0v-1h-1.25a.75.75 0 1 1 0-1.5h1.25v-.75h-1.25a.75.75 0 1 1 0-1.5h.859l-1.85-3.204a1 1 0 0 1 1.732-1l1.515 2.624 1.515-2.624a1 1 0 1 1 1.732 1l-1.85 3.204h.847a.75.75 0 1 1 0 1.5h-1.25v.75z"
  }));
};

exports.SvgTransactionFeeYenMajor = SvgTransactionFeeYenMajor;
